import React, { Component } from 'react';

const styles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999
    },
    modal: {
        backgroundColor: '#fff',
        borderRadius: '12px',
        width: '90%',
        maxWidth: '380px',
        padding: '28px 24px',
        boxShadow: '0 8px 30px rgba(0,0,0,0.3)',
        position: 'relative',
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif'
    },
    closeBtn: {
        position: 'absolute',
        top: '12px',
        right: '15px',
        fontSize: '26px',
        cursor: 'pointer',
        color: '#333',
        background: 'none',
        border: 'none',
        padding: 0,
        fontWeight: 'bold',
        lineHeight: 1,
        zIndex: 110
    },
    title: {
        textAlign: 'center',
        margin: '0 0 6px 0',
        fontSize: '24px',
        fontWeight: '800',
        color: '#333'
    },
    subtitle: {
        textAlign: 'center',
        fontSize: '13px',
        color: '#666',
        margin: '0 0 24px 0',
        lineHeight: '1.4'
    },
    imgPlaceholder: {
        width: '100%',
        height: '240px',
        backgroundColor: '#000',
        borderRadius: '10px',
        marginBottom: '20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        border: '1px solid #ddd',
        overflow: 'hidden',
        cursor: 'pointer'
    },
    video: {
        width: '100%',
        height: '100%',
        objectFit: 'cover'
    },
    droomLogo: {
        width: '180px',
        opacity: 0.2
    },
    innerFrame: {
        position: 'absolute',
        border: '2px solid #F37021',
        width: '80%',
        height: '35%',
        borderRadius: '4px',
        pointerEvents: 'none',
        boxShadow: '0 0 0 1000px rgba(0,0,0,0.4)',
        zIndex: 5
    },
    tapToScan: {
        position: 'absolute',
        bottom: '15px',
        left: '0',
        right: '0',
        color: '#fff',
        fontSize: '12px',
        fontWeight: '700',
        textAlign: 'center',
        backgroundColor: 'rgba(243, 112, 33, 0.8)',
        padding: '6px 0',
        zIndex: 6
    },
    actionBtn: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        padding: '12px 0',
        backgroundColor: '#fff',
        color: '#F37021',
        border: '2px solid #F37021',
        borderRadius: '50px',
        fontWeight: '700',
        cursor: 'pointer',
        marginBottom: '15px',
        fontSize: '15px',
        transition: 'all 0.2s'
    },
    fileInput: {
        display: 'none'
    },
    inputSection: {
        marginBottom: '20px'
    },
    textInput: {
        width: '100%',
        padding: '14px',
        border: '1px solid #ccc',
        borderRadius: '6px',
        fontSize: '18px',
        boxSizing: 'border-box',
        textAlign: 'center',
        color: '#333',
        fontWeight: '700',
        backgroundColor: '#fff'
    },
    submitBtn: {
        display: 'block',
        width: '100%',
        padding: '15px',
        backgroundColor: '#F37021',
        color: '#fff',
        border: 'none',
        borderRadius: '8px',
        fontWeight: '700',
        fontSize: '18px',
        cursor: 'pointer'
    },
    disabledBtn: {
        opacity: 0.7,
        cursor: 'not-allowed'
    },
    errorText: {
        color: '#d32f2f',
        fontSize: '13px',
        textAlign: 'center',
        marginTop: '12px',
        fontWeight: '600'
    },
    processingOverlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        borderRadius: '12px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 100,
        textAlign: 'center'
    },
    processingGif: {
        width: '60px',
        marginBottom: '10px'
    },
    processingText: {
        fontSize: '16px',
        color: '#F37021',
        fontWeight: '700',
        marginTop: '10px'
    },
    scannerLine: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '2px',
        background: 'linear-gradient(to bottom, transparent, #F37021, transparent)',
        boxShadow: '0 0 10px #F37021',
        animation: 'scan 2s linear infinite',
        zIndex: 5
    },
    fullScreenOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: '#000',
        zIndex: 10000,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
    },
    fullScreenVideo: {
        width: '100%',
        height: '100%',
        objectFit: 'cover'
    },
    captureBtnCircle: {
        position: 'absolute',
        bottom: '40px',
        width: '70px',
        height: '70px',
        borderRadius: '50%',
        backgroundColor: 'rgba(255, 255, 255, 0.3)',
        border: '4px solid #fff',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10001
    },
    captureBtnInner: {
        width: '54px',
        height: '54px',
        borderRadius: '50%',
        backgroundColor: '#fff'
    },
    fullScreenClose: {
        position: 'absolute',
        top: '20px',
        right: '20px',
        color: '#fff',
        fontSize: '32px',
        cursor: 'pointer',
        zIndex: 10002,
        background: 'none',
        border: 'none'
    }
};

// Add scan animation
if (typeof document !== 'undefined') {
    const styleSheet = document.createElement("style");
    styleSheet.type = "text/css";
    styleSheet.innerText = `
        @keyframes scan {
            0% { top: 0; }
            100% { top: 100%; }
        }
    `;
    document.head.appendChild(styleSheet);
}

class OcrPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            numberPlate: '',
            errorMsg: '',
            isTyping: false,
            showCamera: false,
            isFullScreen: false,
            stream: null,
            scanData: null
        };
        this.videoRef = React.createRef();
        this.canvasRef = React.createRef();
        
        this.handleScan = this.handleScan.bind(this);
        this.animateText = this.animateText.bind(this);
        this.startCamera = this.startCamera.bind(this);
        this.stopCamera = this.stopCamera.bind(this);
        this.captureImage = this.captureImage.bind(this);
        this.toggleFullScreen = this.toggleFullScreen.bind(this);
        this.handleFileUpload = this.handleFileUpload.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (this.props.isOpen && !prevProps.isOpen) {
            this.startCamera();
        }
        if (!this.props.isOpen && prevProps.isOpen) {
            this.stopCamera();
            this.setState({ isFullScreen: false });
        }
    }

    componentWillUnmount() {
        this.stopCamera();
    }

    async startCamera() {
        if (this.state.stream) return;
        this.setState({ errorMsg: '', loading: true });
        try {
            const stream = await navigator.mediaDevices.getUserMedia({
                video: { facingMode: 'environment' }
            });
            this.setState({ stream, showCamera: true, loading: false }, () => {
                if (this.videoRef.current) {
                    this.videoRef.current.srcObject = stream;
                }
            });
        } catch (err) {
            console.error("Camera access denied:", err);
            this.setState({ 
                errorMsg: 'Camera permission denied. Please allow and try again.',
                loading: false 
            });
        }
    }

    stopCamera() {
        if (this.state.stream) {
            this.state.stream.getTracks().forEach(track => track.stop());
            this.setState({ stream: null, showCamera: false, isFullScreen: false });
        }
    }

    toggleFullScreen(e) {
        if (e && e.stopPropagation) e.stopPropagation();
        if (this.state.loading || this.state.isTyping) return;
        this.setState(prevState => ({ isFullScreen: !prevState.isFullScreen }));
    }

    async captureImage(e) {
        if (e && e.stopPropagation) e.stopPropagation();
        if (!this.videoRef.current || !this.canvasRef.current || this.state.loading || this.state.isTyping) return;

        const video = this.videoRef.current;
        const canvas = this.canvasRef.current;
        const context = canvas.getContext('2d');

        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        context.drawImage(video, 0, 0, canvas.width, canvas.height);

        this.setState({ loading: true, errorMsg: '' });
        
        canvas.toBlob(async (blob) => {
            // Stop camera immediately to free resources
            if (this.state.isFullScreen) {
                this.stopCamera();
            }
            
            // Create a File object from the blob to ensure it has a name and extension 
            // This is required for Laravel's file validation (mimes:jpg,jpeg,png)
            const captureFile = new File([blob], "capture.jpg", { type: "image/jpeg" });
            
            await this.performScan(captureFile);
            this.setState({ isFullScreen: false });
        }, 'image/jpeg', 0.9);
    }

    async handleFileUpload(e) {
        const file = e.target.files[0];
        if (!file) return;
        await this.performScan(file);
    }

    submitRedirectionForm(data) {
        const { redirect_params, redirect_url } = data;
        if (!redirect_params) {
            console.warn("No redirect params found, falling back to GET redirect");
            window.location.href = redirect_url || '/result';
            return;
        }

        const { suffix, ...params } = redirect_params;
        const actionUrl = `/result?${suffix || 'type=block'}${suffix ? '&type=block' : ''}`;

        const form = document.createElement('form');
        form.method = 'POST';
        form.action = actionUrl;

        Object.keys(params).forEach(key => {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.value = params[key];
            form.appendChild(input);
        });

        document.body.appendChild(form);
        form.submit();
    }

    async performScan(file) {
        this.setState({ loading: true, errorMsg: '' });
        
        try {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('just_ocr', 1);

            const res = await fetch('/scan-vehicle/get-vehicle-obv-history', {
                method: 'POST',
                body: formData
            });
            const response = await res.json();
            
            if (response && (response.code === 'success' || response.status === 'success') && response.data) {
                const data = response.data;
                this.setState({ loading: false, scanData: null }, () => {
                    // Start animation to populate the box
                    this.animateText(data.registration_number, () => {
                        // We stop here. User must click "Check Price" manually to trigger the expensive backend parts.
                        if (data.mmyt_failed) {
                            this.setState({ errorMsg: data.message || 'Plate detected but details missing. Please type manually.' });
                        }
                    });
                });
            } else {
                this.setState({ 
                    errorMsg: response.message || response.errors || 'Plate detection failed. Please try manual entry.',
                    loading: false 
                });
            }
        } catch (err) {
            this.setState({ errorMsg: 'Image scan failed. Please type manually.', loading: false });
        }
    }

    animateText(text, callback) {
        this.setState({ numberPlate: '', isTyping: true });
        let i = 0;
        const interval = setInterval(() => {
            if (i < text.length) {
                const nextChar = text[i].toUpperCase();
                this.setState((prevState) => ({
                    numberPlate: prevState.numberPlate + nextChar
                }));
                i++;
            } else {
                clearInterval(interval);
                this.setState({ isTyping: false }, () => {
                    if (callback) callback();
                });
            }
        }, 60);
    }

    async handleScan() {
        if (!this.state.numberPlate || this.state.isTyping || this.state.loading) return;

        const rcRegex = /^[a-zA-Z0-9]{5,11}$/;
        if (!rcRegex.test(this.state.numberPlate)) {
            this.setState({ errorMsg: 'Please enter a valid registration number (5-11 alphanumeric characters).' });
            return;
        }

        // Reset scan data since we are doing a fresh full-flow request now
        this.setState({ loading: true, errorMsg: '', scanData: null });

        try {
            const res = await fetch('/scan-vehicle/get-vehicle-obv-history', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ rc_number: this.state.numberPlate })
            });
            const response = await res.json();
            
            if (response && (response.code === 'success' || response.status === 'success') && response.data) {
                const data = response.data;
                if (data.redirect_url || data.redirect_params) {
                    this.submitRedirectionForm(data);
                } else if (data.mmyt_failed) {
                    this.setState({ errorMsg: data.message || 'Vehicle found but details could not be matched. Please type manually.', loading: false });
                } else {
                    throw new Error('Details fetched but no redirection data provided.');
                }
            } else {
                throw new Error(response.message || response.errors || 'Vehicle details not found.');
            }
        } catch (err) {
            console.error("HandleScan Error:", err);
            this.setState({ errorMsg: err.message, loading: false });
        }
    }

    render() {
        if (!this.props.isOpen) return null;

        return (
            <div style={styles.overlay} onClick={this.props.onClose}>
                <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
                    <button type="button" style={styles.closeBtn} onClick={this.props.onClose}>&times;</button>
                    
                    {this.state.loading && !this.state.showCamera && (
                        <div style={styles.processingOverlay}>
                            <img src="https://cdn1.acedms.com/images/obv_new_loader.gif" style={styles.processingGif} alt="Loading" />
                            <div style={styles.processingText}>Processing...</div>
                        </div>
                    )}

                    <h3 style={styles.title}>Scan Number Plate</h3>
                    <p style={styles.subtitle}>Point camera at the number plate and tap</p>

                    <div style={styles.imgPlaceholder} onClick={this.toggleFullScreen}>
                        {this.state.showCamera ? (
                            <React.Fragment>
                                <video 
                                    ref={this.videoRef} 
                                    autoPlay 
                                    playsInline 
                                    style={{...styles.video, opacity: this.state.isFullScreen ? 0 : 1}} 
                                />
                                <div style={styles.innerFrame}></div>
                                <div style={styles.scannerLine}></div>
                                <div style={styles.tapToScan}>TAP TO EXPAND</div>
                            </React.Fragment>
                        ) : (
                            <React.Fragment>
                                <img src="https://cdn1.acedms.com/photos/images/web/droom_logo_grey.png" style={styles.droomLogo} alt="Droom" />
                                <div style={styles.innerFrame}></div>
                            </React.Fragment>
                        )}
                        {this.state.loading && (
                            <div style={{...styles.processingOverlay, backgroundColor: 'rgba(255,255,255,0.7)'}}>
                                 <img src="https://cdn1.acedms.com/images/obv_new_loader.gif" style={styles.processingGif} alt="Loading" />
                            </div>
                        )}
                    </div>

                    <canvas ref={this.canvasRef} style={{ display: 'none' }} />

                    <label style={styles.actionBtn}>
                        <input type="file" accept="image/*" style={styles.fileInput} onChange={this.handleFileUpload} disabled={this.state.loading} />
                        <span>Upload from Gallery</span>
                    </label>

                    <div style={styles.inputSection}>
                        <input 
                            type="text" 
                            placeholder="DL xxxx 9980" 
                            style={styles.textInput}
                            value={this.state.numberPlate}
                            onChange={(e) => this.setState({ numberPlate: e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '') })}
                            disabled={this.state.isTyping || this.state.loading}
                        />
                    </div>

                    <button 
                        type="button"
                        style={{...styles.submitBtn, ...(this.state.loading || this.state.isTyping || !this.state.numberPlate ? styles.disabledBtn : {})}}
                        onClick={this.handleScan}
                        disabled={this.state.loading || this.state.isTyping || !this.state.numberPlate}
                    >
                        {this.state.loading ? 'Checking...' : 'Check Price'}
                    </button>
                    
                    {this.state.errorMsg && (
                        <div style={styles.errorText}>{this.state.errorMsg}</div>
                    )}
                </div>

                {this.state.showCamera && this.state.isFullScreen && (
                    <div style={styles.fullScreenOverlay} onClick={this.captureImage}>
                        <button type="button" style={styles.fullScreenClose} onClick={this.toggleFullScreen}>&times;</button>
                        <video 
                            ref={(el) => {
                                if (el && this.state.stream) el.srcObject = this.state.stream;
                            }} 
                            autoPlay 
                            playsInline 
                            style={styles.fullScreenVideo} 
                        />
                        <div style={styles.captureBtnCircle}>
                            <div style={styles.captureBtnInner}></div>
                        </div>
                        <div style={{...styles.innerFrame, width: '90%', top: '30%', boxShadow: '0 0 0 1000px rgba(0,0,0,0.2)'}}></div>
                    </div>
                )}
            </div>
        );
    }
}

export default OcrPopup;
